export const INIT_AJAX_CALL = "INIT_AJAX_CALL";
export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";
export const AJAX_CALL_SUCCESS = "AJAX_CALL_SUCCESS";
export const AJAX_CALL_ERROR = "AJAX_CALL_ERROR";

export const AUTH_USER = "AUTH_USER";

export const GET_ROLES = 'GET_ROLES'
export const GET_SELECTED_ROLE = 'GET_SELECTED_ROLE'
export const CLEAR_SELECTED_ROLE = 'CLEAR_SELECTED_ROLE'

export const GET_DICTIONARY = 'GET_DICTIONARY'
export const GET_PROFILE = 'GET PROFILE'
export const CLEAR_PROFILE = 'CLEAR_PROFILE'

export const STORE_TEST_CENTER = 'STORE_TEST_CENTER'

export const STORE_LANG = 'STORE_LANG'

export const TOGGLE_MEDIA_DATABASE = 'TOGGLE_MEDIA_DATABASE'

export const STORE_SIDEMENU = 'STORE_SIDEMENU'
export const STORE_ASSIGNED_SIDEMENU = 'STORE_ASSIGNED_SIDEMENU'

export const GET_PLATFORM_CONFIG = 'GET_PLATFORM_CONFIG'